<script setup lang="ts">
import { getLocaleValue } from '@/js/helper/locale.ts';
import { formatPrice } from '@/js/utils.ts';
import { computed } from 'vue';

const props = defineProps<{
  totalSum: number
}>();
const formattedTotalSum = computed(() => formatPrice(props.totalSum));
</script>

<template>
  <div class="cart-totals">
    <div class="cart-totals__wrap">
      <div class="cart-totals__title">
        {{ getLocaleValue('your_order') }}
      </div>
      <div class="cart-totals__list">
        <div class="cart-totals__item">
          <span>{{ getLocaleValue('sum') }}:</span>
          <span>{{ formattedTotalSum }}</span>
        </div>
      </div>
    </div>

    <div class="cart-totals__footer">
      <div class="cart-totals__list">
        <div class="cart-totals__item cart-totals__item_large">
          <span>{{ getLocaleValue('total') }}:</span>
          <span>{{ formattedTotalSum }}</span>
        </div>
      </div>
      <slot />
    </div>
  </div>
</template>

<style lang="scss">
.cart-totals {
  &__title {
    display: flex;
    align-items: center;
    font-size: 28px;
    margin-bottom: 44px;
  }

  &__list {
    font-size: 19px;
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5px;

    &_large {
      font-weight: 500;
      font-size: 24px;
    }
  }

  &__wrap {
    padding: 30px 30px 50px;
    border: 1px solid var(--border-color);
    border-radius: 3px;
  }

  &__footer {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px 30px;
    background-color: #fff;
    border: 1px solid var(--border-color);
  }

  @media (max-width: 992px) {
    &__wrap {
      display: none;
    }

    &__footer {
      padding: 8px;
    }

    &__item {
      &_large {
        font-size: 20px;
      }
    }
  }
}
</style>
